import { Button, CloseButton, Modal } from "react-bootstrap"
import { CONTENT_GROUP_ACTION, CONTENT_GROUP_MESSAGE } from "../../constants"
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

function InvalidStagePopup({}) {
    const dispatch = useDispatch();
    const { data, isInvalidStageModalOpen } = useSelector(state => state.invalid_stage_popup);
    const first_card = data?.cards && data.cards.length > 0 ? data.cards[0] : null;
    const message = `${CONTENT_GROUP_MESSAGE.CONTENT_GROUP_TIME_TRACKED_EXIST}`;
   
    const handleOpenContentGroupPopUp = (id, data) => {
        dispatch({ type: CONTENT_GROUP_ACTION.CLOSE_CARD_MODAL });
        setTimeout(() => {
            dispatch({ type: CONTENT_GROUP_ACTION.OPEN_CARD_MODAL, payload: data });
            dispatch({type: CONTENT_GROUP_ACTION.CLOSE_INVALID_STAGE_MODAL})   
        }   , 100);
    }

    const workspace_name = first_card ? <>"{first_card?.workspace_name}" workspace</> : <>"Workspace"</>;

    const getMessage = () => { 
        if (first_card) {
            return <p className="mb-4 text-center"><span className="link_color font-weight-bold cursor-pointer" onClick={() => handleOpenContentGroupPopUp(first_card.id, first_card)}>"{first_card.name}"</span> card is currently being time-tracked in {workspace_name}. Move out of time-tracking stage to proceed.</p>
        } else {
            return <p className="mb-4 text-center">{ message }</p>
        } 
    }

    const onHide = () => {
        dispatch({ type: CONTENT_GROUP_ACTION.CLOSE_INVALID_STAGE_MODAL });
    }

    useEffect   (() => {    

        return () => {
            // Cleanup function to close the modal when the component unmounts
            dispatch({ type: CONTENT_GROUP_ACTION.CLOSE_INVALID_STAGE_MODAL });
        }   
    }, []);

    if (!isInvalidStageModalOpen) {
        return null;
    }

    return (
        <Modal
            show={isInvalidStageModalOpen}
            keyboard={true}
            className="invalid-stage-popup"
        >
            <Modal.Body className="custom_body">
                <div onClick={onHide} className="close_modal"><CloseButton title="Close" /></div>
                {getMessage()}
                <div className="w-100 text-center">
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={onHide}
                        className="mx-3 px-3"
                    >
                        Ok
                    </Button>
                </div>

            </Modal.Body>
        </Modal>
    )
}

export { InvalidStagePopup }